<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewProcedureDirectoryDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {
      },
      formData: {},
      templates: [],
      initialExamState: { id: 1, translatedName: 'offen' },
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
    this.fetchTemplates()
      .then(({ data }) => {
        if (data && data.length > 0) this.templates = data.map(it => it.name);
      });
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('procedureDirectoryDetails', ['saveProcedureDirectory', 'fetchTemplates']),
    ...mapActions('procedureDirectoryList', { fetchData: 'fetchProcedureDirectoryList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveProcedureDirectory(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Das Audit wurde angelegt.');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/procedureDirectory/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
    onPrivacyOfficerResponsible() {
      if (this.formData.isPrivacyOfficerResponsible) {
        this.formData.privacyOfficer = null;
      }
    },
    onClientRespAffiliate() {
      if (this.formData.isClientRespAffiliate) {
        this.formData.responsibleAffiliate = null;
      }
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neues Verfahren
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.name"
                :error-messages="validationErrorMessages.name"
                label="Bezeichnung"
                height="22"
                class="caption"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-combobox
                style="height: 22px !important; margin-top: -6px;"
                :items="templates"
                v-model="formData.template"
                label="Vorlage"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <rbx-remote-combobox
                v-model="formData.examState"
                :selected="initialExamState"
                label="Status"
                domain="ExamState"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <rbx-remote-combobox
                v-model="formData.responsibleUser"
                label="Bearbeiter"
                domain="User"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <rbx-remote-combobox
                v-model="formData.organizationalUnit"
                label="Organisationseinheit"
                domain="OrganizationalUnit"
              />
            </v-flex>

            <v-flex xs12 md6 py-0/>

            <v-flex xs12 md6 py-0>
              <rbx-remote-combobox
                v-model="formData.responsibleAffiliate"
                label="Verantwortlicher"
                :selected="formData.responsibleAffiliate"
                domain="Affiliate"
                :disabled="formData.isClientRespAffiliate"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-checkbox
                v-model="formData.isClientRespAffiliate"
                label="Mandant selbst verantwortlich"
                :selected="formData.isClientRespAffiliate"
                class="caption"
                hide-details
                @click.native="onClientRespAffiliate"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-text-field
                v-model="formData.privacyOfficer"
                label="Datenschutzbeauftragter"
                height="22"
                class="caption"
                :disabled="formData.isPrivacyOfficerResponsible"
              />
            </v-flex>

            <v-flex xs12 md6 py-0>
              <v-checkbox
                v-model="formData.isPrivacyOfficerResponsible"
                label="Unternehmens-Datenschutzbeauftragter ist zuständig"
                class="caption"
                hide-details
                @click.native="onPrivacyOfficerResponsible"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; neu
              </v-list-tile-title>
            </v-list-tile>
            <!-- Does not work.
            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Details
              </v-list-tile-title>
            </v-list-tile>
            -->
          </v-list>
        </v-menu>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
